import { Decimal } from 'decimal.js';
import { TAX_PERCENT_DECIMALS } from './tax-percent-decimals.js';
/** A stored tax percent at the precision updateSalesOrder accepts, so it resubmits cleanly. */
export function roundTaxPercent(percent) {
    return new Decimal(String(percent)).toDecimalPlaces(TAX_PERCENT_DECIMALS).toNumber();
}
//# sourceMappingURL=round-tax-percent.js.map